module.exports = __webpack_public_path__ + "static/img/teacherCount.20fe7935.png";